<template>
  <div>
    <v-dialog scrollable v-model="model" persistent max-width="1000px">
      <material-card
        v-if="editedItem"
        :title="
          $t(
            'components.employers.correct_store_information_dialog.correct_store_{0}_information',
            [trans(editedItem, 'Name')]
          )
        "
        :color="$vuetify.theme.themes.light.success"
        icon="add"
      >
        <v-card-text v-if="editedItem !== null && editedItem !== undefined">
          <v-dialog v-model="dialogs.cancel" persistent max-width="400">
            <v-card>
              <v-card-title class="headline">
                {{
                  $t(
                    "globals.cancel_wizard"
                  )
                }}
              </v-card-title>
              <v-card-text>
                {{
                  $t(
                    "components.employers.employers_stores_dialog.if_you_exit_the_wizard_any_changes_made_so_far"
                  )
                }}
              </v-card-text>
              <v-card-actions>
                <v-btn text @click="dialogs.cancel = false">
                  {{ $t("globals.keep_working") }}
                </v-btn>
                <v-btn color="primary" text @click="cancelStoreWizard">
                  {{ $t("globals.cancel_anyway") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-row>
            <v-stepper
              v-model="step"
              vertical
              class="elevation-0"
              style="width: 100%;"
            >
              <v-stepper-step :complete="step > 1" step="1" :editable="!isNew">
                {{ $t("components.inmemorystores.store_info") }}
                <small>
                  {{ $t("components.inmemorystores.fill_in_the_fields") }}
                </small>
              </v-stepper-step>

              <v-stepper-content step="1">
                <v-container>
                  <v-row>
                    <v-col>
                      <v-form ref="storeInfoForm" v-model="valid.storeInfo">
                        <v-container fluid>
                          <v-row>
                            <v-col xs="12" sm="6" md="4" lg="4">
                              <trans-textbox
                                v-model="editedItem.Current"
                                :label="$t('globals.name')"
                                :rules="[$rules.required]"
                                field="Name"
                                class="required"
                              ></trans-textbox>
                            </v-col>
                            <v-col xs="12" sm="6" md="4" lg="4">
                              <no-autocomplete-textfield
                                v-model="editedItem.Current.Number"
                                :label="$t('globals.number')"
                                :rules="[
                                  $rules.required,
                                  $rules.numeric,
                                  $rules.dynamic.upToLength(4),
                                  $rules.notOnlyFourZeros,
                                ]"
                                class="required"
                              ></no-autocomplete-textfield>
                            </v-col>
                            <v-col
                              xs="12"
                              sm="6"
                              md="4"
                              lg="4"
                              v-if="planOptions.HasBillingImport"
                            >
                              <v-checkbox
                                v-model="editedItem.Current.IsAssignable"
                                v-bind:false-value="true"
                                v-bind:true-value="false"
                                :label="$t('components.inmemorystores.is_corporate')"
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
                <v-btn
                  v-if="editedItem.Current.IsAssignable !== false"
                  color="primary"
                  @click="step = 2"
                  :disabled="!valid.storeInfo"
                >
                  {{ $t("globals.continue") }}
                </v-btn>
              </v-stepper-content>

              <v-stepper-step
                :complete="step > 2"
                step="2"
                :editable="!isNew"
                v-if="editedItem.Current.IsAssignable !== false"
              >
                {{ $t("components.inmemorystores.store_contact_details") }}
                <small>
                  {{ $t("components.inmemorystores.fill_in_the_fields") }}
                </small>
              </v-stepper-step>

              <v-stepper-content
                step="2"
                v-if="editedItem.Current.IsAssignable !== false"
              >
                <v-container>
                  <v-row>
                    <v-col>
                      <v-form
                        ref="storeDetailsForm"
                        v-model="valid.storeDetails"
                        v-if="editedItem !== null && editedItem !== undefined"
                      >
                        <v-container fluid>
                          <v-row>
                            <v-col xs="12" sm="6" md="4" lg="4">
                              <no-autocomplete-textfield
                                v-model="editedItem.Current.PhoneNumber"
                                :label="$t('globals.telephone')"
                                required
                                :rules="[rules.phone]"
                                v-mask="telephoneMask"
                              ></no-autocomplete-textfield>
                            </v-col>
                            <v-col xs="12" sm="6" md="4" lg="4">
                              <no-autocomplete-textfield
                                v-model="editedItem.Current.PhoneNumber2"
                                :label="$t('headers.employers.phone2')"
                                required
                                :rules="[rules.phone]"
                                v-mask="telephoneMask"
                              ></no-autocomplete-textfield>
                            </v-col>
                            <v-col xs="12" sm="6" md="4" lg="4">
                              <no-autocomplete-textfield
                                v-model="editedItem.Current.Fax"
                                :label="$t('globals.fax_number')"
                                required
                                :rules="[rules.phone]"
                                v-mask="telephoneMask"
                              ></no-autocomplete-textfield>
                            </v-col>
                            <v-col xs="12" sm="6" md="4" lg="4">
                              <no-autocomplete-textfield
                                v-model="editedItem.Current.Email"
                                :label="$t('headers.contacts.email')"
                                required
                                :rules="[$rules.email]"
                              ></no-autocomplete-textfield>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
                <v-btn text @click="step = 1">
                  {{ $t("globals.back") }}
                </v-btn>
                <v-btn
                  v-if="editedItem.Current.IsAssignable !== false"
                  color="primary"
                  @click="continueToStoreAddress()"
                  :disabled="!valid.storeDetails"
                >
                  {{ $t("globals.continue") }}
                </v-btn>
              </v-stepper-content>

              <v-stepper-step
                v-if="editedItem.Current.IsAssignable !== false"
                :complete="step > 3"
                step="3"
                :editable="!isNew"
              >
                {{ $t("components.inmemorystores.store_address") }}
                <small>
                  {{ $t("components.inmemorystores.add_address_to_this_store") }}
                </small>
              </v-stepper-step>
              <v-stepper-content
                step="3"
                v-if="editedItem.Current.IsAssignable !== false"
              >
                <v-container>
                  <address-form
                    ref="storeAddress"
                    :provinces="options.Models.Province"
                    :item="editedItem.Current"
                    v-if="editedItem"
                  ></address-form>
                </v-container>
                <v-btn text @click="storeAddressBack()">
                  {{ $t("globals.back") }}
                </v-btn>
              </v-stepper-content>
            </v-stepper>
          </v-row>
        </v-card-text>
        <div v-else>
          <v-row justify="center">
            <v-progress-circular
              :size="70"
              :width="7"
              color="accent"
              indeterminate
            ></v-progress-circular>
          </v-row>
        </div>
        <v-card-actions>
          <v-btn :disabled="saving" text @click="dialogs.cancel = true">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid.store()"
            :loading="saving"
            color="primary"
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import { locker } from "@/mixins/locker";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import { translate2 } from "@/trans2";
import TransTextbox from "@/components/TransTextbox";
import AddressForm from "@/components/AddressForm";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";

export default {
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    TransTextbox,
    AddressForm,
  },
  mixins: [locker],
  props: ["model", "id"],
  directives: { mask },
  data() {
    return {
      error: null,
      saving: false,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      dialogs: {
        cancel: false,
      },
      editedItem: null,
      step: 1,
      valid: {
        storeInfo: false,
        storeDetails: false,
        storeAddress: () => {
          // console.log("valid store address", this.editedItem);
          if (!this.editedItem) return false;
          if (this.editedItem.Current.IsAssignable === false) return true;
          // console.log(this.$refs.storeAddress.valid, this.$refs.storeAddress.dirty);
          return (
            this.$refs.storeAddress &&
            (this.$refs.storeAddress.valid || !this.$refs.storeAddress.dirty)
          );
        },
        store: () => {
          console.log("valid store: ", this.editedItem);
          if (!this.editedItem) return false;
          return (
            this.valid.storeInfo &&
            this.valid.storeDetails &&
            this.valid.storeAddress()
          );
        },
      },
      telephoneMask: "(###) ### - ####",
      rules: {
        phone: (v) => {
          let val = this.unmask(v, this.telephoneMask);
          return !val || this.$rules.phone(val);
        },
      },
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["options", "planOptions"]),
    ...mapGetters("common", ["language"]),
    isNew() {
      return this.id === null || this.id === undefined;
    },
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          this.loadItem();
        }
      },
    },
  },
  mounted() {
    if (this.model) {
      this.loadItem();
    }
  },
  methods: {
    ...mapActions("plansMembers", [
      "getStoreForCorrectInformation",
      "correctStoreInformation",
    ]),
    async loadItem() {
      try {
        if (this.lockId) {
          this.editedItem = await this.getStoreForCorrectInformation({
            planIdentityId: this.selectedPlan.Id,
            storeId: this.id,
          }).data;
        } else {
          this.editedItem = await this.lock(
            this.getStoreForCorrectInformation,
            {
              planIdentityId: this.selectedPlan.Id,
              storeId: this.id,
            },
            () => {}
          );
        }
        if (
          this.editedItem.Current.Address === null ||
          this.editedItem.Current.Address === undefined
        ) {
          this.editedItem.Current.Address = {};
        }
      } catch (error) {
        this.error = error;
      }
    },
    save() {
      this.editedItem.Current.Name = this.editedItem.Current.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Name;
      let item = JSON.parse(JSON.stringify(this.editedItem));
      //console.log(item, this.editedItem);
      item.Current.IsAssignable =
        item.Current.IsAssignable !== false ? true : false;

      if (!item.Current.IsAssignable) {
        delete item.Current.Address;
      }
      if (item.Current.Address) {
        // if (item.Address.StreetNumber)
        //   item.Address.StreetNumber = parseInt(item.Address.StreetNumber);
        // else delete item.Address.StreetNumber;
        if (item.Current.Address.Province) {
          item.Current.Address.ProvinceId = item.Current.Address.Province.Id;
          delete item.Current.Address.Province;
          // if (item.Address.StreetNumber)
          //   item.Address.StreetNumber = parseInt(item.Address.StreetNumber);
          // else delete item.Address.StreetNumber;
          item.Current.Address.StoreId = item.Id;
        } else {
          delete item.Current.Address;
        }
      }
      if (
        item.Current.PhoneNumber !== null &&
        item.Current.PhoneNumber !== undefined
      ) {
        item.Current.PhoneNumber = this.unmask(
          item.Current.PhoneNumber,
          this.telephoneMask
        );
      }
      if (
        item.Current.PhoneNumber2 !== null &&
        item.Current.PhoneNumber2 !== undefined
      ) {
        item.Current.PhoneNumber2 = this.unmask(
          item.Current.PhoneNumber2,
          this.telephoneMask
        );
      }
      if (
        item.Current.PhoneNumber2 !== null &&
        item.Current.PhoneNumber2 !== undefined
      ) {
        item.Current.PhoneNumber2 = this.unmask(
          item.Current.PhoneNumber2,
          this.telephoneMask
        );
      }
      if (item.Current.Fax !== null && item.Current.Fax !== undefined) {
        item.Current.Fax = this.unmask(item.Current.Fax, this.telephoneMask);
      }
      delete item["@odata.context"];
      this.tryCorrectInformation(item);
    },
    unmask(v, mask) {
      // console.log(v, mask);
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    async tryCorrectInformation(item) {
      this.saving = true;
      try {
        await this.correctStoreInformation({
          planIdentityId: this.selectedPlan.Id,
          payload: item,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;

        if (this.$refs.storeInfoForm)
          this.$refs.storeInfoForm.resetValidation();
        if (this.$refs.storeDetailsForm)
          this.$refs.storeDetailsForm.resetValidation();

        this.step = 1;

        this.unlock();
        this.$emit("close");
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    cancelStoreWizard() {
      this.dialogs.cancel = false;
      this.editedItem = null;
      this.unlock();
      this.$emit("close");
    },
    trans(item, field) {
      return translate2(item, field);
    },
    continueToStoreAddress() {
      if (this.$refs.storeAddress) {
        this.$refs.storeAddress.validate();
      }
      this.step = 3;
    },
    storeAddressBack() {
      if (this.$refs.storeAddress) {
        this.$refs.storeAddress.resetValidation();
      }
      this.step = 2;
    },
  },
};
</script>
